






































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
// @ts-ignore
import PQueue from "p-queue";
// @ts-ignore
import { ArrowRightIcon, SendIcon, StopCircleIcon } from "vue-feather-icons";
import { Component } from "vue-property-decorator";
import Header from "@/models/header";
import Request from "@/models/checkRequest/request";
import { SET_QUEUE_BUSY } from "@/store/mutation-types";

@Component({
  components: {
    ArrowRightIcon,
    SendIcon,
    StopCircleIcon,
  },
  computed: {
    ...mapState("headers", ["headers"]),
    ...mapState("projects", ["queueBusy"]),
    ...mapState("settings", [
      "maxConcurrentChecksFree",
      "maxConcurrentChecksPremium",
    ]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
    ...mapGetters("projects", ["requests"]),
  },
})
export default class Queue extends Vue {
  queue!: PQueue;
  queueStarted = false;

  // mapState / mapGetters
  requests!: Array<Request>;
  headers!: Array<Header>;
  queueBusy!: boolean;
  maxConcurrentChecksFree!: number;
  maxConcurrentChecksPremium!: number;
  hasActiveSubscription!: boolean;

  get maxConcurrentChecks(): number {
    return this.hasActiveSubscription
      ? this.maxConcurrentChecksPremium
      : this.maxConcurrentChecksFree;
  }

  created() {
    // Create a queue for the requests
    // this.queue = new Queue(this.queueMaxConcurrent, this.queueMax)
    this.queue = new PQueue({ concurrency: this.maxConcurrentChecks });
  }

  stop() {
    //
    // Start the queue
    this.queueStarted = false;
    this.$store.commit(`projects/${SET_QUEUE_BUSY}`, false);
    this.queue.clear();
  }

  toggle(oneByOne: boolean) {
    if (!this.queueStarted) {
      if (oneByOne) {
        this.queue = new PQueue({ concurrency: 1 });
      } else {
        this.queue = new PQueue({ concurrency: this.maxConcurrentChecks });
      }

      this.start();
      return;
    } else {
      this.stop();
      return;
    }
  }

  start() {
    this.queueStarted = true;

    this.$store.commit(`projects/${SET_QUEUE_BUSY}`, true);

    const requestsIdle = this.requests.filter(
      (cr) => cr.isValid && !cr.isReady
    );

    requestsIdle.forEach((request) => {
      //
      if (!request.isValid) {
        return;
      }
      //
      // Add the request to the queue
      this.queue.add(() => {
        //
        // Our queue needs a Promise
        // and the store returns it
        return this.$store.dispatch("projects/send", request).catch(() => {
          // nothing
        });
      });
    });
    //
    // Always update status in the store once the queue is empty
    this.queue.onIdle().then(() => {
      //
      //
      this.queueStarted = false;
      //
      // Wait 1 second before hiding the progressbar
      setTimeout(() => {
        this.$store.commit(`projects/${SET_QUEUE_BUSY}`, false);
      }, 1000);
    });
  }
}
